import script from "./AppTrow.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTrow.vue?vue&type=script&setup=true&lang=js"

import "./AppTrow.vue?vue&type=style&index=0&id=2ee94e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee94e48"]])

export default __exports__